import React from 'react';
import ErrorMessage from '../presentational/shared/ErrorMessage';

export const Error404: React.FC = () => {
  return <ErrorMessage>The requested resource does not exist.</ErrorMessage>
}
